(() => {
  function pushEvent(name, payload = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      ...payload
    });
  }

  function getAttribution() {
    try {
      return JSON.parse(sessionStorage.getItem('mimosa_lead_attribution') || '{}');
    } catch (_) {
      return {};
    }
  }

  function init(section) {
    if (!section || section.dataset.mtyInit === 'true') return;
    section.dataset.mtyInit = 'true';

    if (section.dataset.hideChrome === 'true') {
      document.body.classList.add('mimosa-thankyou-mode');
    }

    const attribution = getAttribution();
    const payload = {
      lead_source: attribution.qr_source || attribution.utm_source || 'direct',
      lead_campaign: attribution.utm_campaign || ''
    };

    pushEvent('mimosa_thankyou_view', payload);

    const instagram = section.querySelector('[data-instagram-cta]');
    if (instagram) {
      instagram.addEventListener('click', () => {
        pushEvent('mimosa_instagram_click', payload);
      });
    }

    const secondary = section.querySelector('[data-thankyou-secondary]');
    if (secondary) {
      secondary.addEventListener('click', () => {
        pushEvent('mimosa_thankyou_secondary_click', payload);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mimosa-thankyou]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[data-mimosa-thankyou]'));
  });
})();